import Dropdown from "../Dropdown"
import withData from "../withData"

export default withData(`/api/treatment-status`, item => {
    return {
        value: item.id
        , name: item.attributes.name
    }
})(Dropdown)